export class userRequest {
  fname?: string;
  lname?: string;
  email?: string;
}
